var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-overlay"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imageSrc),expression:"imageSrc"}],attrs:{"alt":_vm.imageAlt,"width":_vm.imageWidth,"height":_vm.imageHeight}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3c430b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-content/utils/ImageOverlay.vue
// module id = null
// module chunks = 